import { Toast } from '@journ/bloom/toast'
import { registerServiceWorker } from './register-sw'
import { useEffect } from 'react'

// registerType is 'prompt', so a new worker waits rather than taking over
// mid-session: reloading under someone writing a plan would lose the form.
const ReloadPrompt = () => {
	useEffect(() => {
		registerServiceWorker(({ update }) => {
			Toast.show('A new version is ready.', {
				duration: Number.POSITIVE_INFINITY,
				action: {
					label: 'Reload',
					onClick: () => {
						void update()
					},
				},
			})
		})
	}, [])

	return null
}

export { ReloadPrompt }
